import { forecastSchema } from "@/schemas/prevision-data-schema";
import { IFetchPevision } from "@/types/prevision-type";

export const fetchPrevision = async (
	cityId: string,
): Promise<IFetchPevision> => {
	try {
		const res = await fetch(
			`https://kuwait.exelys.io/kuwait_stations_forecast/kuwait_forecast_${cityId}.json`,
		);

		if (!res.ok) {
			throw new Error("Une erreur est survenue");
		}

		const data = await res.json();

		const validatedData = forecastSchema.parse(data);

		return {
			isLoading: false,
			error: null,
			data: validatedData,
		};
	} catch {
		return {
			data: null,
			isLoading: false,
			error: "Une erreur est survenue",
		};
	}
};
